import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var InfoSmall = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M8.086 5.254a.902.902 0 01.08-.004c.553 0 1 .504 1 1.125v6.875h1a1 1 0 010 2h-4a1 1 0 010-2h1v-6H6a1 1 0 110-2h2c.029 0 .058.001.086.004zm-.211-1.337a1.458 1.458 0 110-2.917 1.458 1.458 0 010 2.917z" })), '0 0 16 16', 'InfoSmall');
//# sourceMappingURL=InfoSmall.js.map